// Code generated by master-scheme ServiceTypesGenerator - DO NOT EDIT
// Generator: /Users/victorvins/Projects/master-scheme/dsl/src/ts-api/ServiceTypesGenerator.scala

import { postEndpoint } from '@innolab-trader/tradovate-transport'
import type { ValidationError } from '@innolab-trader/tradovate-types'

export interface RestoreCredentialsRequest {
  emailOrUsername: string
  organization?: string
  experience?: string
  locale?: string
}

export interface SimpleResponse {
  errorText?: string
  ok: boolean
}

/**
 * Validate RestoreCredentialsRequest request
 *
 * Follows Rust validation pattern with structured errors
 *
 * @param request - The request object to validate
 * @returns Array of validation errors, empty if valid
 *
 * @example
 * ```typescript
 * const errors = validateRestoreCredentialsRequest(requestData)
 * if (errors.length > 0) {
 *   return { status: 400, errors }
 * }
 * ```
 */
export function validateRestoreCredentialsRequest(request: RestoreCredentialsRequest): ValidationError[] {
  const errors: ValidationError[] = []

  const req = request as unknown as Record<string, unknown>
  if (req.emailOrUsername === undefined || req.emailOrUsername === null) {
    errors.push({
      field: 'emailOrUsername',
      code: 'required',
      message: 'emailOrUsername is required'
    })
  }
  if (typeof req.emailOrUsername === 'string' && req.emailOrUsername.length > 64) {
    errors.push({
      field: 'emailOrUsername',
      code: 'too_long',
      message: 'emailOrUsername must not exceed 64 characters',
      argument: '64'
    })
  }
  if (typeof req.emailOrUsername === 'string' && req.emailOrUsername.trim() === '') {
    errors.push({
      field: 'emailOrUsername',
      code: 'required',
      message: 'emailOrUsername cannot be empty'
    })
  }

  if (typeof req.organization === 'string' && req.organization.length > 64) {
    errors.push({
      field: 'organization',
      code: 'too_long',
      message: 'organization must not exceed 64 characters',
      argument: '64'
    })
  }

  if (typeof req.experience === 'string' && req.experience.length > 64) {
    errors.push({
      field: 'experience',
      code: 'too_long',
      message: 'experience must not exceed 64 characters',
      argument: '64'
    })
  }

  if (typeof req.locale === 'string' && req.locale.length > 64) {
    errors.push({
      field: 'locale',
      code: 'too_long',
      message: 'locale must not exceed 64 characters',
      argument: '64'
    })
  }

  return errors
}

export const restoreCredentialsRequest = postEndpoint<RestoreCredentialsRequest, SimpleResponse>('/auth/restoreCredentialsRequest')
